function extractResponsePayload(result) {
    if (result?.status === "fulfilled") {
        return result.value?.data || {};
    }
    return result?.reason?.response?.data || {};
}

function buildFailureMessage(payload) {
    const cancelStatus = String(payload?.cancel_status || "").toLowerCase();
    const currentStatus = String(payload?.current_status || "").toLowerCase();

    if (cancelStatus === "already_claimed" || currentStatus === "submitting") {
        return "This queued trade was already being submitted and could not be cancelled.";
    }
    if (cancelStatus === "already_executing") {
        return "This queued trade is already executing and has been left for broker-side reconciliation.";
    }
    if (cancelStatus === "already_submitted" || currentStatus === "submitted") {
        return "This queued trade was already submitted and can no longer be cancelled from the local queue.";
    }
    if (
        cancelStatus === "already_executed" ||
        currentStatus === "filled" ||
        currentStatus === "partially_filled"
    ) {
        return "This queued trade already executed and can no longer be cancelled.";
    }
    if (cancelStatus === "already_cancelled" || currentStatus === "cancelled") {
        return "This queued trade was already cancelled. The queue has been refreshed.";
    }
    if (cancelStatus === "not_found") {
        return "This queued trade could not be found. The queue may already have changed.";
    }
    return payload?.error || "Could not cancel this queued trade yet. The queue has been refreshed.";
}

export function summarizeCancelResults(results) {
    const payloads = results.map(extractResponsePayload);
    const hasFailure = results.some((result) => result.status !== "fulfilled");
    const allCancelled = !hasFailure && payloads.every((payload) => {
        const status = String(payload?.status || "").toLowerCase();
        const cancelStatus = String(payload?.cancel_status || "").toLowerCase();
        return status === "cancelled" || status === "already_cancelled" || cancelStatus === "cancelled" || cancelStatus === "already_cancelled";
    });

    if (allCancelled) {
        return {
            ok: true,
            message: "Queued trade cancelled.",
        };
    }

    const firstPayload = payloads.find((payload) => payload && (payload.cancel_status || payload.current_status || payload.error)) || {};
    return {
        ok: false,
        message: buildFailureMessage(firstPayload),
    };
}
